import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgbToastModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastAlertSignalStore} from '../../shared/store/alert/toast-alert.signal-store';
import {IconComponent} from '../../shared/component/icon/icon.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'ucs-toast-container',
  templateUrl: './toast-container.component.html',
  imports: [
    NgbToastModule, IconComponent, NgClass
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent {

  readonly toastAlertStore = inject(ToastAlertSignalStore);
}
